import React from 'react'

import { Icon } from '@fourthwall/components'
import { ArrowShortLeftIcon } from '@fourthwall/icons'

import type { SelectedCategory } from '../../../../types'
import { getBreadcrumbsString, getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs'
import * as S from './styled'

type HeaderProps = {
  selectedCategory: NonNullable<SelectedCategory>
  onClick: () => void
  focused?: boolean
}

export const Header = ({ selectedCategory, focused = false, onClick }: HeaderProps) => {
  const hasChildren = selectedCategory.children.length > 0

  return (
    <S.Container tabIndex={-1} onClick={onClick} $focused={focused}>
      <S.IconContainer>
        <Icon component={ArrowShortLeftIcon} height={12} />
      </S.IconContainer>
      <S.Content>
        <S.MainCategory>
          {hasChildren
            ? selectedCategory.name
            : getDirectParentFromBreadcrumbs(selectedCategory.breadcrumbs)}
        </S.MainCategory>
        <S.Subcategories>
          {getBreadcrumbsString(selectedCategory.breadcrumbs, hasChildren ? 1 : 2)}
        </S.Subcategories>
      </S.Content>
    </S.Container>
  )
}
